import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const artistService = {
	list(params?: ListParams) {
		return apiClient.get("/artists", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/artists/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/artists", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/artists/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/artists/${id}`).then((r) => r.data);
	},
	uploadFaces(id: number, files: File[], primaryIndex = 0) {
		const fd = new FormData();
		for (const file of files) fd.append("photos[]", file);
		fd.append("is_primary_index", String(primaryIndex));
		return apiClient
			.post(`/artists/${id}/faces`, fd, {
				headers: { "Content-Type": "multipart/form-data" },
			})
			.then((r) => r.data);
	},
	deleteFace(id: number, faceId: number) {
		return apiClient.delete(`/artists/${id}/faces/${faceId}`).then((r) => r.data);
	},
	sync(id: number) {
		return apiClient.post(`/artists/${id}/sync`).then((r) => r.data);
	},
};
